import user from './user'
import tool from './tool'

export default {
  user,
  tool
}
